import { render, staticRenderFns } from "./voice-message-item.vue?vue&type=template&id=2238b4de"
import script from "./voice-message-item.vue?vue&type=script&lang=js"
export * from "./voice-message-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2238b4de')) {
      api.createRecord('2238b4de', component.options)
    } else {
      api.reload('2238b4de', component.options)
    }
    module.hot.accept("./voice-message-item.vue?vue&type=template&id=2238b4de", function () {
      api.rerender('2238b4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/call/voice-message-item.vue"
export default component.exports